/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Email_VerifiedInputs */

const he_account_delivery_email_verified = /** @type {(inputs: Account_Delivery_Email_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאומת`)
};

const en_account_delivery_email_verified = /** @type {(inputs: Account_Delivery_Email_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

/**
* | output |
* | --- |
* | "Verified" |
*
* @param {Account_Delivery_Email_VerifiedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_email_verified = /** @type {((inputs?: Account_Delivery_Email_VerifiedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Email_VerifiedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_email_verified(inputs)
	return en_account_delivery_email_verified(inputs)
});